import * as Yup from "yup";

export const weighbillValidationSchema = Yup.object().shape({
  supplier_id: Yup.number()
    .required("Supplier is required")
    .positive("Supplier is required"),

  branch_id: Yup.number()
    .required("Branch is required")
    .positive("Branch is requried "),
  weighbill_items: Yup.array().required("Weighbill items are required"),
});

export const weighbillItemValidationSchema = Yup.object().shape({
  quantity: Yup.number()
    .required("Quantity is required")
    .positive("Quantity cannot be 0."),
  cost_price: Yup.number()
    .required("Cost price is required")
    .positive("Cost price cannot be 0."),
  discount_percentage: Yup.number()
    .min(0, "Discount percentage cannot be negative")
    .max(100, "Discount percentage cannot be more than 100"),
  round_up: Yup.number()
    .required("Round up is required")
    .min(0, "Round up cannot be negative"),
  weight: Yup.number().required("Weight is required"),
  // .positive("Weight must be a positive number"),
  product_id: Yup.number()
    .required("Product ID is required")
    .positive("Product ID is required"),
});
